import React from 'react';
import DefectDot from '../../Components/DefectDot';
import RegularDot from '../../Components/RegularDot';
import EditedDot from '../../Components/EditedDot';
import AlertDot from '../../Components/AlertDot';

export const renderCustomDot = (props, item, config, className = '', onDotClick = null) => {
  const { cx, cy, payload, stroke, fill } = props;

  if (config?.customDotRenderer) {
    return config.customDotRenderer(props, item);
  }

  const hasDefects = payload.defects && payload.defects.length > 0;
  const hasAlert = payload.alertTriggered === true;
  const isEdited = payload.isEdited === true;

  const handleClick = onDotClick ? (e) => {
    e.stopPropagation();
    onDotClick(payload);
  } : undefined;

  // Priority: Defects > Alert > Edited > Regular
  if (hasDefects) {
    return <DefectDot
             cx={cx}
             cy={cy}
             className={className}
             payload={payload}
           />;
  } else if (hasAlert) {
    return (
      <g onClick={handleClick} style={{ cursor: onDotClick ? 'pointer' : 'default' }}>
        <AlertDot
          cx={cx}
          cy={cy}
          decision={payload.alertDecision}
          className={className}
        />
      </g>
    );
  } else if (isEdited) {
    return <EditedDot
             cx={cx}
             cy={cy}
             stroke={stroke}
             fill={item.defaultColor}
             className={className}
             onClick={handleClick}
           />;
  } else {
    return (
      <g onClick={handleClick} style={{ cursor: onDotClick ? 'pointer' : 'default' }}>
        <RegularDot
          cx={cx}
          cy={cy}
          stroke={stroke}
          fill={item.defaultColor}
          strokeWidth={2}
          r={6}
          className={className}
        />
      </g>
    );
  }
};

export const renderActiveDot = (props, item, handleClick, className = '') => {
  const { cx, cy, payload, stroke, fill } = props;
  const hasDefects = payload.defects && payload.defects.length > 0;
  const hasAlert = payload.alertTriggered === true;
  const isEdited = payload.isEdited === true;

  return (
    <g
      onClick={(e) => handleClick && handleClick(e, payload, item)}
      style={{ cursor: handleClick ? "pointer" : "default" }}
      className={className}
    >
      {hasDefects ? (
        <DefectDot
          cx={cx}
          cy={cy}
          className={className}
          payload={payload}
        />
      ) : hasAlert ? (
        <AlertDot
          cx={cx}
          cy={cy}
          decision={payload.alertDecision}
          className={className}
        />
      ) : isEdited ? (
        <EditedDot
          cx={cx}
          cy={cy}
          stroke={stroke}
          fill={fill}
          className={className}
        />
      ) : (
        <circle
          cx={cx}
          cy={cy}
          r={8}
          stroke={stroke || '#8884d8'}
          strokeWidth={2}
          fill={fill || '#fff'}
        />
      )}
    </g>
  );
}; 